// Components
import { Box, Typography } from '@/CommonComponents'
// Constants
import { COLORS } from '@/lib/constants/colors'
const TAB_STYLE = {
  px: 3,
  py: 1,
  cursor: 'pointer',
  '&:hover': {
    backgroundColor: COLORS.BACKGROUND.DEFAULT,
  },
}
interface ITabSelectorProps<T extends string> {
  tabs: { id: T; label: string }[]
  selectedTab: T
  setSelectedTab: (tab: T) => void
}

export default function TabSelector<T extends string>({ tabs, selectedTab, setSelectedTab }: ITabSelectorProps<T>) {
  return (
    <Box sx={{ mb: 2, display: 'flex', borderBottom: `1px solid ${COLORS.BACKGROUND.DARK}` }}>
      {tabs.map(({ id, label }) => (
        <Box
          key={id}
          onClick={() => {
            setSelectedTab(id)
          }}
          sx={{
            ...TAB_STYLE,
            color: selectedTab === id ? COLORS.PRIMARY.MAIN : 'inherit',
            borderBottom: selectedTab === id ? `2px solid ${COLORS.PRIMARY.MAIN}` : 'none',
          }}
        >
          <Typography variant="body2" bold>
            {label}
          </Typography>
        </Box>
      ))}
    </Box>
  )
}
